import { CustomDropdownSelection } from "src/app/angular-elements/shared/components/ag-grid-cell-renderers/interfaces/ag-grid-cell-renderer.interface";
import { DataCardItem } from "src/app/angular-elements/shared/components/data-display-card/interfaces/data-display-card.interface";


export enum STATUS_OPTION_SERVICE_VALUES {
  NOT_STARTED = "NOT_STARTED",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  SUBMITTED = "SUBMITTED",
  DENIED = "DENIED"
}

export enum STATUS_OPTION_DISPLAY_VALUES {
  NOT_STARTED = "Not Started",
  PENDING = "Pending",
  APPROVED = "Approved",
  SUBMITTED = "Submitted",
  DENIED = "Denied"
}

export enum FILTER_OPTS {
  STATUS = "STATUS",
  APP_NO = "APP_NO",
  ENROLLMENT_TYPE = "ENROLLMENT_TYPE",
  PLAN_TYPE = "PLAN_TYPE",
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME"
}

export enum SORT_OPTS {
  STATUS = "STATUS",
  CREATED_DATE = "CREATED_DATE",
  LAST_MODIFIED_DATE = "LAST_MODIFIED_DATE"
}

export const STATUS_OPTIONS_DETAILS: CustomDropdownSelection[] = [
  {
    displayValue: STATUS_OPTION_DISPLAY_VALUES.NOT_STARTED,
    icon: "do_not_disturb_on",
    className: "together-blue",
    value: STATUS_OPTION_SERVICE_VALUES.NOT_STARTED,
  },
  {
    displayValue: STATUS_OPTION_DISPLAY_VALUES.PENDING,
    icon: "clock_loader_60",
    className: "power-yellow",
    value: STATUS_OPTION_SERVICE_VALUES.PENDING,
  },
  {
    displayValue: STATUS_OPTION_DISPLAY_VALUES.APPROVED,
    icon: "check_circle",
    className: "ahn-green",
    value: STATUS_OPTION_SERVICE_VALUES.APPROVED,
  },
  {
    displayValue: STATUS_OPTION_DISPLAY_VALUES.DENIED,
    icon: "cancel",
    className: "ahn-magenta",
    value: STATUS_OPTION_SERVICE_VALUES.DENIED,
  },
  {
    displayValue: STATUS_OPTION_DISPLAY_VALUES.SUBMITTED,
    icon: "check_circle",
    className: "light-healthtech-teal",
    value: STATUS_OPTION_SERVICE_VALUES.SUBMITTED,
  },
];

export const GRID_DATA_CARD_CONFIGS: {[key in STATUS_OPTION_SERVICE_VALUES]: DataCardItem} = {
  [STATUS_OPTION_SERVICE_VALUES.NOT_STARTED]: {
    theme: "DEFAULT",
    cardTitle: "Not Started",
    cardIcon: "do_not_disturb_on"
  },
  [STATUS_OPTION_SERVICE_VALUES.PENDING]: {
    theme: "POWER_YELLOW",
    cardTitle: "Pending",
    cardIcon: "clock_loader_60"
  },
  [STATUS_OPTION_SERVICE_VALUES.APPROVED]: {
    theme: "SUCCESS",
    cardTitle: "Approved",
  },
  [STATUS_OPTION_SERVICE_VALUES.DENIED]: {
    theme: "REJECTED",
    cardTitle: "Denied"
  },
  [STATUS_OPTION_SERVICE_VALUES.SUBMITTED]: {
    theme: "LIGHT_HEALTHTECH_TEAL",
    cardTitle: "Submitted",
    cardIcon: "outbox"
  },
}

export const SupportDocumentTypesByLifeEvent = {
  BIRTH: [
    {
      label: "Birth Certificate",
      value: "Birth Certificate",
    },
    {
      label: "Proof of claims for birth",
      value: "Proof of claims for birth",
    },
  ],
  ADOPTION: [
    {
      label: "Legal papers for adoption",
      value: "Legal papers for adoption",
    },
  ],
  FOSTER_CARE: [
    {
      label: "Legal papers for foster care",
      value: "Legal papers for foster care",
    },
  ],
  COURT_ORDER_MN: [
    {
      label: "Court order",
      value: "Court order",
    },
  ],
  MARRIAGE: [
    {
      label: "Proof from prior carrier of MEC",
      value: "Proof from prior carrier of MEC",
    },
    {
      label: "Marriage certificate",
      value: "Marriage certificate",
    },
  ],

  PREGNANCY: [
    {
      label: "Coverage termination notice",
      value: "Coverage termination notice",
    },
  ],
  LOSS_OF_COVERAGE_EMPLOYER: [
    {
      label: "Coverage termination letter",
      value: "Coverage termination letter",
    },
  ],
  LOSS_OF_COVERAGE_BENEFIT: [
    {
      label: "Coverage termination letter",
      value: "Coverage termination letter",
    },
  ],
  LEGAL_SEPARATION: [
    {
      label: "Coverage termination letter/notice",
      value: "Coverage termination letter/notice",
    },
  ],
  MEDICARE_ENTITLED: [
    {
      label: "Coverage termination letter/notice",
      value: "Coverage termination letter/notice",
    },
  ],
  DEATH_POLICYHOLDER: [
    {
      label: "Coverage termination letter/notice",
      value: "Coverage termination letter/notice",
    },
  ],
  LOSS_CHILD_DEPENDENT: [
    {
      label: "Coverage termination letter",
      value: "Coverage termination letter",
    },
  ],
  LOSS_OF_MEDICAID: [
    {
      label: "Coverage termination notice",
      value: "Coverage termination notice",
    },
  ],
  LOSS_OF_COBRA: [
    {
      label: "COBRA eligibility notice",
      value: "COBRA eligibility notice",
    },
    {
      label: "COBRA coverage termination notice",
      value: "COBRA coverage termination notice",
    },
    {
      label: "Non-calendar year policy termination notice",
      value: "Non-calendar year policy termination notice",
    },
    {
      label: "Employer COBRA contributions termination notice",
      value: "Employer COBRA contributions termination notice",
    },
  ],
  MOVING_OUT_HMO: [
    {
      label: "Coverage termination letter",
      value: "Coverage termination letter",
    },
    {
      label: "Proof of address change",
      value: "Proof of address change",
    },
  ],
  RESIDENCE_CHANGE: [
    {
      label: "Rental/lease agreement",
      value: "Rental/lease agreement",
    },
    {
      label: "Deed",
      value: "Deed",
    },
    {
      label: "Purchase Agreement",
      value: "Purchase Agreement",
    },
    {
      label: "Driver's License or State Photo ID",
      value: "Driver's License or State Photo ID",
    },
    {
      label: "Utility Bill",
      value: "Utility Bill",
    },
  ],
  RELEASE_INCARCERATION: [
    {
      label: "Prison release form",
      value: "Prison release form",
    },
  ],
  MILITARY_SERVICE: [
    {
      label: "Departure date paperwork",
      value: "Departure date paperwork",
    },
  ],
  FINANCIAL_CHANGE: [
    {
      label: "Copy of MNsure eligibility notice",
      value: "Copy of MNsure eligibility notice",
    },
  ],

  ICHRA: [
    {
      label: "ICHRA form",
      value: "ICHRA form",
    },
  ],
  QSEHRA: [
    {
      label: "QSEHRA form",
      value: "QSEHRA form",
    },
  ],
  DEFAULT_OTHER: [
    {
      label: "Other",
      value: "Other",
    },
  ],
};

export enum APPLICATION_ACTION_OPTIONS {
  VIEW_DOCUMENTS = "viewDocuments",
  VIEW_NOTES = "viewNotes",
  SAVE_NOTES = "saveNotes",
  EDIT_NOTES = "editNotes",
  DOWNLOAD_APPLICATION = "downloadApplication",
  UPLOAD_DOCUMENTS = "uploadDocuments",
}

export enum RELATIONSHIP_TO_APPLICANT{
  ['Domesticpartner'] = 'Domestic Partner',
  ['Spouse'] = 'Spouse',
  ['Subscriber'] = 'Subscriber',
  ['Dependent'] = 'Dependent'
}

export enum SEP_REVIEW_DASHBOARD_COLUMN_NAME {
    ACTION_MENU = "actionMenu",
    APPLICATION_DATE = "applicationDate",
    APPLICATION_NUMBER = "applicationNumber",
    DETAIL_DISPLAY_OBJECT = 'detailDisplayObj',
    DOCUMENT_ACTIONS = "documentActions",
    DOCUMENTS = 'documents',
    ENROLLMENT_OBJ = "enrollmentObj",
    LAST_EDITED = "lastEdited",
    LAST_EDITED_BY = "lastEditedBy",
    LIFE_EVENT = "lifeEvent",
    NOTES = 'notes', 
    STATUS = "status",
    SUBSCRIBER_DOB = "subscriberDob",
    SUBSCRIBER_NAME = "subscriberName"
}